module.exports = __webpack_public_path__ + "static/media/gestures.06300488.png";